


























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
	components: {},
})
export default class MailAttachment extends Vue {

	@Prop({
		required: true,
		type: String
	})
	public filename!: string;

	@Prop({
		default: 0,
	})
	public filesize!: number | null;

	@Prop({
		default: false,
		type: Boolean
	})
	public deletable!: boolean;

	@Prop({
		default: false,
		type: Boolean
	})
	public isDefaultAttachment!: boolean;

	get fileExtension(): string {
		if (this.filename) {
			return this.filename.toLocaleLowerCase().split('.').pop() || '';
		}
		return '';
	}

	get filetypeIcon(): string {
		switch (this.fileExtension) {
			case 'pdf':
				return 'fa fa-file-pdf-o';
			case 'doc':
			case 'docx':
				return 'fa fa-file-word-o';
			case 'xls':
			case 'xlsx':
				return 'fa fa-file-excel-o';
			case 'ppt':
			case 'pptx':
				return 'fa fa-file-powerpoint-o';
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
				return 'fa fa-file-image-o';
			case 'zip':
			case 'rar':
			case '7z':
				return 'fa fa-file-archive-o';
			case 'txt':
				return 'fa fa-file-text-o';
			default:
				return 'fa fa-file-o';
		}
	}

	deleteAttachment() {
		if (confirm('Diesen Dateianhang wirklich entfernen?')) {
			this.$emit('delete');
		}
	}

	formatFilesize(sizeInBytes: number): string {
		const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
		return (sizeInBytes / Math.pow(1024, i)).toFixed(1) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
	}
}
